import { useState, useEffect } from "react";
import { changeLogInstanceTypes, changeLogType } from "../../../@types/components/changeLog.types";
import { Member } from "../../../@types/member.types";
import { Paycheck } from "../../../@types/paycheck.types";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import prefixCharacterAddition from "../../../utils/commonFunctions/prefixCharacterAddition";

import "./changeLog.css";

const ChangeLogInformation = ({ changeLogInstance }: any) => {
	const [loginstance, setLogInstance] = useState<any>();
	const [changeLog, setChangeLog] = useState<changeLogType>();

	useEffect(() => {
		if (changeLogInstance)
			setLogInstance(
				Object.assign(
					{},
					{
						...changeLogInstance
					}
				)
			);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [changeLogInstance]);

	// console.log("changeLogInstance Log Data1", loginstance?.created_by_details?.role);
	// console.log("changeLogInstance Log Data2", loginstance?.updated_by_details?.role);

	//takes value from created_by_details.
	// useEffect(() => {
	// 	setChangeLog(
	// 		Object.assign(
	// 			{},
	// 			{
	// 				//Before
	// 				// role: loginstance?.created_by_details?.role
	// 				// 	? initCapitalize(loginstance?.created_by_details?.role)
	// 				// 	: loginstance?.created_by_details?.role,
	// 				// name:
	// 				// 	loginstance?.created_by_details?.first_name + " " + loginstance?.created_by_details?.last_name,
	// 				// After
	// 				role: loginstance?.updated_by_details?.role
	// 					? initCapitalize(loginstance?.updated_by_details?.role)
	// 					: loginstance?.updated_by_details?.role,
	// 				name:
	// 					loginstance?.updated_by_details?.first_name + " " + loginstance?.updated_by_details?.last_name,
	// 				updated_on:
	// 					prefixCharacterAddition(new Date(loginstance?.updatedAt as string).getMonth() + 1) +
	// 					"-" +
	// 					prefixCharacterAddition(new Date(loginstance?.updatedAt as string).getDate()) +
	// 					"-" +
	// 					new Date(loginstance?.updatedAt as string).getFullYear() +
	// 					"  " +
	// 					prefixCharacterAddition(new Date(loginstance?.updatedAt as string).getHours()) +
	// 					":" +
	// 					prefixCharacterAddition(new Date(loginstance?.updatedAt as string).getMinutes())
	// 			}
	// 		)
	// 	);
	// }, [
	// 	// loginstance?.created_by_details?.first_name,
	// 	// loginstance?.created_by_details?.last_name,
	// 	// loginstance?.created_by_details?.role,
	// 	loginstance?.updated_by_details?.first_name,
	// 	loginstance?.updated_by_details?.last_name,
	// 	loginstance?.updated_by_details?.role,
	// 	loginstance?.updatedAt
	// ]);

	//Here, if updated_by_details is null or undefined, it will automatically pick the values from created_by_details.(Temporary solved)
	useEffect(() => {
		if (!loginstance) return;

		const userDetails = loginstance?.updated_by_details ?? loginstance?.created_by_details;

		setChangeLog({
			role: userDetails?.role ? initCapitalize(userDetails?.role) : userDetails?.role,
			name: `${userDetails?.first_name} ${userDetails?.last_name}`,
			updated_on:
				prefixCharacterAddition(new Date(loginstance?.updatedAt || loginstance?.createdAt).getMonth() + 1) +
				"-" +
				prefixCharacterAddition(new Date(loginstance?.updatedAt || loginstance?.createdAt).getDate()) +
				"-" +
				new Date(loginstance?.updatedAt || loginstance?.createdAt).getFullYear() +
				"  " +
				prefixCharacterAddition(new Date(loginstance?.updatedAt || loginstance?.createdAt).getHours()) +
				":" +
				prefixCharacterAddition(new Date(loginstance?.updatedAt || loginstance?.createdAt).getMinutes())
		});
	}, [
		loginstance?.updated_by_details,
		loginstance?.created_by_details,
		loginstance?.updatedAt,
		loginstance?.createdAt
	]);

	return (
		<div className="change-log-information-container">
			<span>Last update on </span>
			<span className="log-time">{changeLog?.updated_on} </span>
			<span>by </span>
			<span className="log-role"> {changeLog?.role}</span>
			<span className="log-name">: {changeLog?.name}</span>
		</div>
	);
};

export default ChangeLogInformation;
